module.exports = __webpack_public_path__ + "img/pass.700b9955.svg";